import React, { useState, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import DatePicker from "react-widgets/DatePicker";
import moment from "moment";
import { useTranslation } from "react-i18next";

const JobCardSearch = (props) => {
  const formRef = useRef(null);
  const [requiredFrom, setRequiredFrom] = useState("");
  const [requiredTo, setRequiredTo] = useState("");
  const [custCode, setCustCode] = useState("");
  const [planType, setPlanType] = useState("");
  const [size, setSize] = useState("");
  const [priority, setPriority] = useState("regular");
  const [siliconize, setSiliconize] = useState(" - ");
  const { t } = useTranslation();

  const handlePriorityChange = (e) => {
    if (e.target.checked) {
      setPriority("urgent");
    } else {
      setPriority("regular");
    }
  };
  const handleSiliconize = (e) => {
    if (e.target.checked) {
      setSiliconize("siliconize");
    } else {
      setPriority(" - ");
    }
  };
  const handleSearch = () => {
    let filters = {
      requiredFrom,
      requiredTo,
      custCode,
      planType,
      size,
      priority,
      siliconize,
    };
    props.onSearch(filters);
  };

  return (
    <DropdownButton
      id="dropdown-button-drop-down-centered"
      className="searchDropdown"
      drop="down-centered"
      title="Search"
    >
      <Dropdown.ItemText xs={12} md={12} lg={12}>
        <Form noValidate ref={formRef}>
          <Form.Group controlId="formGridEmail">
            <Row className="mb-3" xs={12} md={12} lg={12}>
              <Col sm={12} md={6} lg={6} className="searchLeftRightPadding">
                <Form.Label>
                  {t("msg_trasaction.msg_generatejobcard.requiredFrom")}
                </Form.Label>
                <DatePicker
                  required
                  min={new Date()}
                  placeholder="From Date"
                  valueFormat={{ dateStyle: "medium" }}
                  onChange={(e) => {
                    const formattedDate = moment(e).isValid()
                      ? moment(e).format("YYYY-MM-DD")
                      : "";
                    setRequiredFrom(formattedDate);
                    //setRequiredFrom(moment(e).format('YYYY-MM-DD') || "")
                  }}
                  formats="dd/MM/yyyy" 
                  autoFocus
                />
              </Col>
              <Col sm={12} md={6} lg={6} className="searchLeftRightPadding">
                <Form.Label>
                  {t("msg_trasaction.msg_generatejobcard.requiredTo")}
                </Form.Label>
                <DatePicker
                  required
                  min={new Date()}
                  placeholder="To Date"
                  name="requiredTo"
                  valueFormat={{ dateStyle: "medium" }}
                  onChange={(e) => {
                    const formattedDate = moment(e).isValid()
                      ? moment(e).format("YYYY-MM-DD")
                      : "";
                      setRequiredTo(formattedDate);
                  }}
                  formats={"yyyy-MM-dd"}
                  autoFocus
                />
              </Col>
            </Row>
          </Form.Group>
          <Form.Group controlId="formGridEmail">
            <Row className="mb-3" xs={12} md={12} lg={12}>
              <Col sm={12} md={6} lg={6} className="searchLeftRightPadding">
                <Form.Label>
                  {t("msg_trasaction.msg_generatejobcard.customercode")}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="custCode"
                  value={custCode}
                  onChange={(e) => {
                    setCustCode(e.target.value);
                  }}
                  placeholder={t(
                    "msg_trasaction.msg_generatejobcard.customercode"
                  )}
                />
              </Col>
              <Col sm={12} md={6} lg={6} className="searchLeftRightPadding">
                <Form.Label>
                  {t("msg_trasaction.msg_generatejobcard.planType")}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="planType"
                  value={planType}
                  onChange={(e) => {
                    setPlanType(e.target.value);
                  }}
                  placeholder={t("msg_trasaction.msg_generatejobcard.planType")}
                />
              </Col>
            </Row>
          </Form.Group>
          <Form.Group className="mb-3" controlId="formGridAddress1">
            <Row className="mb-3 searchLeftRightPadding">
              <Form.Label>
                {t("msg_trasaction.msg_generatejobcard.size")}
              </Form.Label>
              <Form.Control
                type="text"
                name="size"
                value={size}
                onChange={(e) => {
                  setSize(e.target.value);
                }}
                placeholder={t("msg_trasaction.msg_generatejobcard.size")}
              />
            </Row>
          </Form.Group>

          <Form.Group className="mb-3" id="formGridCheckbox">
            <Row className="mb-3 searchLeftRightPadding" xs={12} md={12} lg={12}>
              <Col sm={12} md={6} lg={6} className="my-1">
                <Form.Check
                  type="checkbox"
                  onChange={(e) => handlePriorityChange(e)}
                  label="URGENT"
                />
              </Col>
              <Col sm={12} md={6} lg={6} className="my-1">
                <Form.Check
                  type="checkbox"
                  onChange={(e) => handleSiliconize(e)}
                  label="SILICONIZE"
                />
              </Col>
            </Row>
          </Form.Group>
        </Form>
        <Button variant="primary" type="submit" onClick={() => handleSearch()}>
          {t("msg_trasaction.msg_generatejobcard.search")}
        </Button>
      </Dropdown.ItemText>
    </DropdownButton>
  );
};

export default JobCardSearch;
